module.exports = __webpack_public_path__ + "static/media/afikoman-bag-front.b5a385a3.png";